import { render, staticRenderFns } from "./CheckShensu.vue?vue&type=template&id=67bd1f8d"
import script from "./CheckShensu.vue?vue&type=script&lang=js"
export * from "./CheckShensu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67bd1f8d')) {
      api.createRecord('67bd1f8d', component.options)
    } else {
      api.reload('67bd1f8d', component.options)
    }
    module.hot.accept("./CheckShensu.vue?vue&type=template&id=67bd1f8d", function () {
      api.rerender('67bd1f8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/components/CheckShensu.vue"
export default component.exports